<template>
  <el-dialog :title="formData.id ? 'Засварлах' : 'Шинэ зардлын төрөл үүсгэх'" v-model="createCostTypeDialog" width="50%"
    @close="handleClose">
    <div>
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="120px">
        <el-form-item label="Нэр" prop="name">
          <el-input v-model="formData.name" placeholder="Нэрийг оруулна уу"></el-input>
        </el-form-item>
        <el-form-item label="Тайлбар" prop="description">
          <el-input type="textarea" v-model="formData.description" placeholder="Тайлбарыг оруулна уу"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">Хадгалах</el-button>
          <el-button @click="handleClose">Цуцлах</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import services from '@/services'
import {
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,
  ElMessage
} from 'element-plus'
import {
  mapActions,
  mapState
} from 'vuex'

export default {
  name: 'CreateCostTypeDialog',

  components: {
    ElForm,
    ElFormItem,
    ElInput,
    ElButton
  },
  computed: {
    ...mapState(['createCostTypeDialog'])
  },
  props: {
    selectedCostType: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      formData: {
        name: '',
        description: ''
      },
      rules: {
        name: [{
          required: true,
          message: 'Нэрийг оруулна уу',
          trigger: 'blur'
        }]
      }
    }
  },
  watch: {
    selectedCostType: {
      immediate: true,
      handler (newValue) {
        if (newValue && newValue.id) {
          this.formData = {
            ...newValue
          }
        } else {
          this.formData = {
            name: '',
            description: ''
          }
        }
      }
    }
  },
  methods: {
    ...mapActions(['setCreateCostTypeDialog']),
    handleClose () {
      this.formData = {
        name: '',
        description: ''
      }
      this.setCreateCostTypeDialog(false)
    },
    async submitForm () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          try {
            let response
            if (this.formData.id) {
              response = await services.update('costTypes', this.formData)
            } else {
              response = await services.create('costTypes', this.formData)
            }
            if (response) {
              ElMessage.success(this.formData.id ? 'Амжилттай шинэчиллээ!' : 'Амжилттай үүсгэлээ!')
              this.handleClose()
              this.$emit('refresh')
            }
          } catch (error) {
            console.error('API Request Error:', error.message)
            ElMessage.error(error.message || 'Алдаа гарлаа')
          }
        } else {
          console.log('Алдаа гарлаа, шаардлагатай талбаруудыг бөглөнө үү')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
  .el-form {
    max-width: 600px;
    margin: 0 auto;
  }
</style>
